import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import {
  AutocompleteElement,
  TextFieldElement
} from 'components/muiInputWrappers';
import { FormItem } from 'components/shared';
import useGetAllProjects from 'hooks/catalog/useGetAllProjects';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  clientName?: string;
  clientNumber?: number;
  projectId?: number;
};

type Props = {
  form: UseFormReturn;
};

function ClientForm({ form }: Props) {
  const { projects, isProjectsLoading } = useGetAllProjects();
  const { t } = useTranslation('global');

  return (
    <Box>
      <Typography>{t('common.commonProperties.clientNumber')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="clientNumber"
        placeholder={t('common.commonProperties.clientNumber')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
      <Typography>{t('common.commonProperties.clientName')}</Typography>
      <TextFieldElement
        control={form?.control}
        name="clientName"
        placeholder={t('common.commonProperties.clientName')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 50,
            message: t('ticket.messages.valueLongerThan50')
          }
        }}
        variant="outlined"
      />
      <Typography>{t('common.commonProperties.project')}:</Typography>
      <FormItem>
        <AutocompleteElement
          autocompleteProps={{
            size: 'small'
          }}
          control={form.control}
          loading={isProjectsLoading}
          name="projectId"
          options={
            projects?.map((project) => ({
              id: project?.id,
              label: project?.name,
              description: project?.description
            })) || []
          }
          matchId
        />
      </FormItem>
    </Box>
  );
}

export default ClientForm;
